
import { useStore } from '@/store'
import { computed, defineComponent, inject, onUnmounted, ref, watch } from 'vue'
import * as RenderingConstants from '@/constants/rendering-constants'
import RenderingPathService from '@/services/rendering/rendering-path.service'
import insideSettings from '@/settings/inside-settings.json'
import SentrySingleton from '@/singletons/sentry-singleton'

export default defineComponent({
  name: 'RenderingRandselInside',
  props: {
    cameraPos: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const store = useStore()
    const emitter: any = inject('emitter')
    const configInsideId = computed(() => store.getters.configInsideId)
    let imagePath = ref('')
    let renderPathService = new RenderingPathService()

    emitter.on('updateConfig', updateRendering)

    // prettier-ignore
    watch(() => configInsideId.value, (_) => { updateRendering() })

    function updateRendering() {
      try {
        const insideId = renderPathService.formatConfig(configInsideId.value, insideSettings.futaNoUraTextures)
        setRendering(insideId)
      } catch (err) {
        SentrySingleton.instance.captureException(err)
      }
    }

    function setRendering(insideId: string | null | undefined) {
      if (!insideId) {
        imagePath.value = ''
        return
      }
      const camPath = 'cam' + (props.cameraPos + 1) + '/'
      const optionPath = 'inside/' + insideId + '.png'
      const path = RenderingConstants.path + camPath + optionPath
      imagePath.value = path
    }

    onUnmounted(() => {
      emitter.off('updateConfig', updateRendering)
    })

    return {
      imagePath
    }
  }
})
